import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { VillageTransportCostEntity } from "./village-transport.entity";
import { getManager, Repository } from "typeorm";
import { CommonResponse } from "@gtpl/shared-models/production-management";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import appSettings from "apps/services/config";

@Injectable()
export class VillageTransportService{
    constructor(
        @InjectRepository(VillageTransportCostEntity) private villageTransportRepo:Repository<VillageTransportCostEntity>
    ){}
    private readonly VillageTransportColumns = [
        "sno", "villagename", "transportcost"
    ];
    
    async saveVillageTransportInfo(formData: any): Promise<CommonResponse> {
        const transactionManager = new GenericTransactionManager();
        try {
            await transactionManager.startTransaction();
            const flag = new Set<boolean>();
            const columnArray = [];
    
            const updatedArray = formData.data.map((obj: any) => {
                const updatedObj: any = {};
                for (const key in obj) {
                    const newKey = key.replace(/\s/g, '').replace(/[\(\)\.]/g, '').replace(/-/g, '').toLowerCase();
                    if (newKey != '') {
                        columnArray.push(newKey);
                        updatedObj[newKey] = obj[key];
                    }
                }
                return updatedObj;
            });
    
            const difference = columnArray.filter((element) => !this.VillageTransportColumns.includes(element));
            console.log("Difference in columns:", difference);
            if (difference.length > 0) {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 1110, "Excel columns don't match. Please attach the correct file.");
            }
    
            const convertedData = updatedArray.map((obj: any) => {
                const updatedObj: any = {};
                for (const key in obj) {
                    const value = obj[key];
                    updatedObj[key] = value === "" ? null : value;
                }
                return updatedObj;
            });
    
            for (const data of convertedData) {
                const repository = transactionManager.getRepository(VillageTransportCostEntity);
    
                // Check if the record exists for the given villageName and additional criteria if any
                const existingRecord = await repository.findOne({
                    where: { villageName: data.villagename },
                });
    
                if (existingRecord) {
                    // Update existing record
                    existingRecord.transportCost = data.transportcost;
    
                    const updatedRecord = await repository.save(existingRecord);
                    if (!updatedRecord) {
                        flag.add(false);
                        await transactionManager.releaseTransaction();
                        return new CommonResponse(false, 0, 'Something went wrong while updating village transport cost information');
                    }
                } else {
                    // Create a new record
                    const newRecord = new VillageTransportCostEntity();
                    newRecord.villageName = data.villagename;
                    newRecord.transportCost = data.transportcost;
    
                    const savedRecord = await repository.save(newRecord);
                    if (!savedRecord) {
                        flag.add(false);
                        await transactionManager.releaseTransaction();
                        return new CommonResponse(false, 0, 'Something went wrong while saving village transport cost information');
                    }
                }
            }
    
            if (!flag.has(false)) {
                await transactionManager.completeTransaction();
                return new CommonResponse(true, 1, 'Data saved successfully');
            } else {
                await transactionManager.releaseTransaction();
                return new CommonResponse(false, 0, 'Something went wrong');
            }
        } catch (err) {
            console.log(err, 'Error');
            await transactionManager.releaseTransaction();
            return new CommonResponse(false, 0, 'Something went wrong');
        }
    }
    
    

    async getAllVillageTransporationCostData():Promise<CommonResponse>{
        try{
            const manager = getManager()
            let query = `select village_transport_id as villageFromId,village_name as villageName, transport_cost as transporttaionCost
            from ${appSettings.masters_db}.village_transport_cost`
            const result = await manager.query(query)
            if(result.length >0){
                return new CommonResponse(true,1,'Data retrived sucessfully',result)
            }else{
                return new CommonResponse(false,0,'No data Found',[])
            }
        }catch(err){
            throw err
        }
    }
    
    
}